// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/cron_aggregate_backfill.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/cron_aggregate_backfill.proto.
 */
export const file_chalk_artifacts_v1_cron_aggregate_backfill: GenFile = /*@__PURE__*/
  fileDesc("CjBjaGFsay9hcnRpZmFjdHMvdjEvY3Jvbl9hZ2dyZWdhdGVfYmFja2ZpbGwucHJvdG8SEmNoYWxrLmFydGlmYWN0cy52MSLvBQoVQ3JvbkFnZ3JlZ2F0ZUJhY2tmaWxsEgwKBG5hbWUYASABKAkSEAoIc2NoZWR1bGUYAiABKAkSEQoJZmlsZV9uYW1lGAMgASgJEhAKCGZlYXR1cmVzGAQgAygJEhEKCXJlc29sdmVycxgFIAMoCRISCgpxdWVyeV90YWdzGAYgAygJEj8KBnRhcmdldBgHIAEoDjIvLmNoYWxrLmFydGlmYWN0cy52MS5Dcm9uQWdncmVnYXRlQmFja2ZpbGxUYXJnZXQSGwoOcmVzb3VyY2VfZ3JvdXAYCCABKAlIAIgBARIvCgtsb3dlcl9ib3VuZBgJIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLdXBwZXJfYm91bmQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEh4KEWFsbG93X2VtcHR5X3RpbGVzGAsgASgISAGIAQESQAoHdGFyZ2V0cxgMIAMoDjIvLmNoYWxrLmFydGlmYWN0cy52MS5Dcm9uQWdncmVnYXRlQmFja2ZpbGxUYXJnZXQSGAoLZW52aXJvbm1lbnQYDSABKAlIAogBARJWCg9wbGFubmVyX29wdGlvbnMYDiADKAsyPS5jaGFsay5hcnRpZmFjdHMudjEuQ3JvbkFnZ3JlZ2F0ZUJhY2tmaWxsLlBsYW5uZXJPcHRpb25zRW50cnkSFwoKbnVtX3NoYXJkcxgPIAEoBUgDiAEBEiMKFmluY2x1ZGVfcGFydGlhbF9idWNrZXQYECABKAhIBIgBARo1ChNQbGFubmVyT3B0aW9uc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoCToCOAFCEQoPX3Jlc291cmNlX2dyb3VwQhQKEl9hbGxvd19lbXB0eV90aWxlc0IOCgxfZW52aXJvbm1lbnRCDQoLX251bV9zaGFyZHNCGQoXX2luY2x1ZGVfcGFydGlhbF9idWNrZXQq2QEKG0Nyb25BZ2dyZWdhdGVCYWNrZmlsbFRhcmdldBIuCipDUk9OX0FHR1JFR0FURV9CQUNLRklMTF9UQVJHRVRfVU5TUEVDSUZJRUQQABIpCiVDUk9OX0FHR1JFR0FURV9CQUNLRklMTF9UQVJHRVRfT05MSU5FEAESKgomQ1JPTl9BR0dSRUdBVEVfQkFDS0ZJTExfVEFSR0VUX09GRkxJTkUQAhIzCi9DUk9OX0FHR1JFR0FURV9CQUNLRklMTF9UQVJHRVRfT05MSU5FX1NVTU1BUklFUxADYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.artifacts.v1.CronAggregateBackfill
 */
export type CronAggregateBackfill = Message<"chalk.artifacts.v1.CronAggregateBackfill"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string schedule = 2;
   */
  schedule: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: repeated string features = 4;
   */
  features: string[];

  /**
   * @generated from field: repeated string resolvers = 5;
   */
  resolvers: string[];

  /**
   * @generated from field: repeated string query_tags = 6;
   */
  queryTags: string[];

  /**
   * TODO: deprecate
   *
   * @generated from field: chalk.artifacts.v1.CronAggregateBackfillTarget target = 7;
   */
  target: CronAggregateBackfillTarget;

  /**
   * @generated from field: optional string resource_group = 8;
   */
  resourceGroup?: string;

  /**
   * @generated from field: google.protobuf.Timestamp lower_bound = 9;
   */
  lowerBound?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp upper_bound = 10;
   */
  upperBound?: Timestamp;

  /**
   * @generated from field: optional bool allow_empty_tiles = 11;
   */
  allowEmptyTiles?: boolean;

  /**
   * @generated from field: repeated chalk.artifacts.v1.CronAggregateBackfillTarget targets = 12;
   */
  targets: CronAggregateBackfillTarget[];

  /**
   * @generated from field: optional string environment = 13;
   */
  environment?: string;

  /**
   * @generated from field: map<string, string> planner_options = 14;
   */
  plannerOptions: { [key: string]: string };

  /**
   * Maximum number of bucket-aligned time-sharded jobs to split each run's window
   * into; the server's per-shard window-width policy may choose fewer. Unset/1
   * preserves the single-job behavior.
   *
   * @generated from field: optional int32 num_shards = 15;
   */
  numShards?: number;

  /**
   * Also write the open bucket on each run, recomputed from its start. Online
   * targets only.
   *
   * @generated from field: optional bool include_partial_bucket = 16;
   */
  includePartialBucket?: boolean;
};

/**
 * Describes the message chalk.artifacts.v1.CronAggregateBackfill.
 * Use `create(CronAggregateBackfillSchema)` to create a new message.
 */
export const CronAggregateBackfillSchema: GenMessage<CronAggregateBackfill> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_cron_aggregate_backfill, 0);

/**
 * @generated from enum chalk.artifacts.v1.CronAggregateBackfillTarget
 */
export enum CronAggregateBackfillTarget {
  /**
   * @generated from enum value: CRON_AGGREGATE_BACKFILL_TARGET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CRON_AGGREGATE_BACKFILL_TARGET_ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * @generated from enum value: CRON_AGGREGATE_BACKFILL_TARGET_OFFLINE = 2;
   */
  OFFLINE = 2,

  /**
   * Publish compact online aggregate summaries.
   *
   * @generated from enum value: CRON_AGGREGATE_BACKFILL_TARGET_ONLINE_SUMMARIES = 3;
   */
  ONLINE_SUMMARIES = 3,
}

/**
 * Describes the enum chalk.artifacts.v1.CronAggregateBackfillTarget.
 */
export const CronAggregateBackfillTargetSchema: GenEnum<CronAggregateBackfillTarget> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_cron_aggregate_backfill, 0);

